import React from 'react';

import CommandBar from '@/components/CommandBar';

const GlobalKeyboardListeners: React.FC = () => {
  return (
    <>
      <CommandBar />
    </>
  );
};

export default GlobalKeyboardListeners;
